<template>
  <div
    id="app"
    :class="`${appLoading ? 'loading' : ''}`"
  >
    <app-header />
    <router-view />
    <notifications
      group="global"
      position="bottom right"
    />
    <div
      v-if="appLoading"
      id="app__loader"
    />
  </div>
</template>
<script>
import Header from './components/header/header.vue';

export default {
    components: {
        'app-header': Header
    },
    computed: {
        auth() {
            return this.$store.getters.isAuthenticated;
        },
        appLoading() {
            return this.$store.getters.isAppLoading;
        }
    },
    created() {
        this.$store.dispatch( 'appLoading', false );
        this.$store.dispatch( 'tryAutoLogin' );
    }
};
</script>
<style>
    #app__loader {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 1;
        background: rgba(0, 0, 0, 0.5) url(/src/assets/imgs/loading.gif) center center/45px 45px no-repeat;
        cursor: wait;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue